import {USER_ROLES} from "@/constants";

export default class WallPolicy
{
    /**
     * Determine whether the user can view any models.
     *
     * @param  {object}  user
     * @return mixed
     */
    viewAny(user)
    {
        return true;
    }

    /**
     * Determine whether the user can view the model.
     *
     * @param  {object}  user
     * @param  {object}  wall
     * @return {mixed}
     */
    view(user, wall)
    {
        return true;
    }

    /**
     * Determine whether the user can create models.
     *
     * @param  {object}  user
     * @return {mixed}
     */
    create(user)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can update the model.
     *
     * @param  {object}  user
     * @param  {object}  wall
     * @return {mixed}
     */
    update(user, wall)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can restore the model.
     *
     * @param  {object}  user
     * @param  {object}  wall
     * @return {mixed}
     */
    restore(user, wall)
    {
        //
    }

    /**
     * Determine whether the user can delete the model.
     *
     * @param  {object}  user
     * @param  {object}  wall
     * @return {mixed}
     */
    delete(user, wall)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can permanently delete the model.
     *
     * @param  {object}  user
     * @param  {object}  wall
     * @return {mixed}
     */
    forceDelete(user, wall)
    {
        //
    }

    /**
     * Determine whether the user can update the walls foundation.
     *
     * @param  {object}  user
     * @param  {object}  wall
     * @return {mixed}
     */
    updateFoundation(user, wall)
    {
        return this.update(user, wall) && !wall.has_completed_foundation_services
    }
}
